import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService, HttpService, LoaderService, ToasterService } from 'common-libs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule
  ],
  providers: [
    LoaderService,
    AuthService,
    BrowserAnimationsModule,
    ToasterService,
  ],
  exports:[
    ToastrModule,
    HttpClientModule
  ]
})
export class CoreModule { }
